import { render, staticRenderFns } from "./CancelledInventoryRequest.vue?vue&type=template&id=27c28ef8&scoped=true&"
import script from "./CancelledInventoryRequest.vue?vue&type=script&lang=js&"
export * from "./CancelledInventoryRequest.vue?vue&type=script&lang=js&"
import style0 from "./CancelledInventoryRequest.vue?vue&type=style&index=0&id=27c28ef8&prod&lang=scss&scoped=true&"
import style1 from "./CancelledInventoryRequest.vue?vue&type=style&index=1&id=27c28ef8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c28ef8",
  null
  
)

export default component.exports